import React, { useState, useEffect } from "react";
import { sendGetRequest } from '../../../helper/Helper'; 

export default function Leaderboard() {
  const [month, setMonth] = useState('Current');
  const [current, setCurrent] = useState([]);
  const [previous, setPrevious] = useState([]);

  useEffect(() => {
    getLeaderData();
  }, [month]);

  const getLeaderData = async () => {
    try {
      const currentResponse = await sendGetRequest('referral/ranking');
      if (currentResponse && currentResponse.status === 200 && currentResponse.data) {
        setCurrent(currentResponse.data); 
      }
    } catch (error) {}

    try {
      const previousResponse = await sendGetRequest('referral/ranking?period=previous');
      if (previousResponse && previousResponse.status === 200 && previousResponse.data) {
        setPrevious(previousResponse.data); 
      }
    } catch (error) {}
  };
  return (
    <>
      <div className="gredientBG  subPad SRTOP p-0 overHide " style={{borderRadius:'15px'}}>
      <div className="">
        <div className="dateEco d-flex flex-wrap justify-content-between align-items-center">
          <h2 className="mb-0 speacialH2">PTGC Leaderboard</h2>
          <div className="filter">
            <span className="perVal fInter d-flex align-items-center gap-2 flex-wrap">
              <span>Month:</span>
              <div className="rTabs">
                <button className={month === "Current" ? 'inputrightCenter active': 'inputrightCenter'} onClick={() => setMonth("Current")}>Current</button>
                <button className={month === "Previous" ? 'inputrightCenter active': 'inputrightCenter'} onClick={() => setMonth("Previous")}>Previous</button>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="">
        <div className="mt-6">
          <div className="row">
            {
              month === "Current" ?
              current && current.length > 0 ? (
              current.map((item, index) => (
                <div
                  key={index}
                  className="col-sm-12 col-lg-6 borderRight mobBorderBottomAdd991"
                  style={{ borderBottom: "1px solid #ffffff10" }}
                >
                  <div className="EcoSN">
                    <div>
                      <div className="perVal fInter d-flex align-items-center justify-content-between flex-wrap mb-0">
                        <span>{item.referred_username}</span>
                        <span>Rank: {index + 1}</span>
                      </div>
                      <h3 className="dollorValue value mt-2">
                        <span className="dollor">$</span>
                        <span className="val">{parseFloat(item.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}</span>
                      </h3>
                      <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                        <span className="wordbreak">{item.referred_wallet}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center p-5">
                <img src="./images/no-data-6.png" className="img-fluid" style={{width: '130px', margin: 'auto'}} /><p>No record found</p>
              </div>
            )
            :
            previous && previous.length > 0 ? (
              previous.map((item, index) => (
                <div
                  key={index}
                  className="col-sm-12 col-lg-6 borderRight mobBorderBottomAdd991"
                  style={{ borderBottom: "1px solid #ffffff10" }}
                >
                  <div className="EcoSN">
                    <div>
                      <div className="perVal fInter d-flex align-items-center justify-content-between flex-wrap mb-0">
                        <span>{item.referred_username}</span>
                        <span>Rank: {index + 1}</span>
                      </div>
                      <h3 className="dollorValue value mt-2">
                        <span className="dollor">$</span>
                        <span className="val">{parseFloat(item.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}</span>
                      </h3>
                      <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                        <span className="wordbreak">{item.referred_wallet}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center p-5">
                <img src="./images/no-data-6.png" className="img-fluid" style={{width: '130px', margin: 'auto'}} /><p>No record found</p>
              </div>
            )
          }
        </div>
      </div>
      </div>
    </div>
    </>
  );
}
